import { render } from "./App.vue?vue&type=template&id=4c1199fb"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4c1199fb&lang=less"

import exportComponent from "D:\\php\\www\\guoranyou\\okguo2018\\template\\tpls\\comApp\\mallOkguo\\v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__